var map = {
	"./icon-class-1.svg": "Eonh",
	"./icon-class-2.svg": "X2e/",
	"./icon-class-3.svg": "9HOq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "R+/k";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/icon\-class\-.*\.svg$
// module id = R+/k
// module chunks = 1